export const getOffset = (page: number, limit: number) => (page - 1) * limit;

export const getPageCount = (count: number, limit: number) => Math.ceil((count ?? 0) / limit);

export const getPage = (offset: number | undefined, limit: number | undefined) => {
  if (offset === undefined || limit === undefined) return undefined;

  return Math.ceil(offset / limit) + 1;
};
